/**
 * Configuration for all Call-to-Action (CTA) links used throughout the application
 * Centralized configuration allows easy updates across the entire site
 */

export const CTA_LINKS = {
  WELLANAIL_PRODUCT: "https://wellanail.com/article/us-7",

  FORTIFYX_PRODUCT: "https://wellanail.com/article/us-7",
} as const;

export type CTALinkKey = keyof typeof CTA_LINKS;
